import React from "react";
import "./snackbar.css";

export default function SnackbarProgress({ open, progress }) {
  return (
    <div className={`snackbar ${open ? "show" : ""}`}>
      <div className="snackbar-content">
        <p>Downloading: {progress}%</p>

        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: progress + "%" }}
          />
        </div>
      </div>
    </div>
  );
}